/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from 'react';
import { Native, env } from '@hb/hbridge';
import { Toast } from '@quarkd/quark-react';
import axios from 'axios';
import {
  FromNativeOrWxParam,
  defaultActionCallback,
  LinkInstance,
} from '@/interface/downAppType';
import {
  getShareDataApi,
  getUserFeedDataApi,
  getUserFeedDetailApi,
  getWxJsConfigSignatureApi,
  requestGetSecondShareCardApi,
} from '@/api/appDownload';
import { ULINKSDK, WXSDK } from './asyncImportJs';
import request from '@/utils/request';
import { DOWNLOAD_IMG } from '@/constants/config';
import { ULinkIdEnum } from '@/constants/enum';

// const ENV = process.env.REACT_APP_ENV || 'fat';
// const baseWxurl =
//   'https://cloud1-7geespkred11a162-1313033190.tcloudbaseapp.com/h5/jump-mp.html';
let curConfigData: Record<string, any> | null = null;

const userAgent = navigator.userAgent.toLowerCase();

const preloadResultMap = new Map();
export const preloadResult = preloadResultMap;

// 跟踪ULink实例，防止重复创建
let ulinkInstance: any = null;

export function shuffleArray(array: any[], start = 0) {
  // 使用Fisher-Yates算法随机打乱数组
  if (start) {
    for (let i = 0, len = array?.length || 0; i < len - start; i++) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }
  for (let i = start || 0, len = array?.length || 0; i < len; i++) {
    const j = Math.floor(Math.random() * (i + 1 - start)) + start;
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function fisherYatesShuffle<T>(array: T[]): T[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function shuffleImgArray<T>(array: T[]): T[] {
  // 先获取最后5个元素
  const lastFiveElements = array.slice(-5);

  // 再使用 Fisher-Yates 算法打乱整个数组
  const shuffledArray = fisherYatesShuffle(array.slice(0, -5));

  return [...shuffledArray, ...lastFiveElements];
}

export function getMockData() {
  return import(/* webpackChunkName: 'mockjs' */ '@/utils/config.mock')
    .then((res: any) => {
      const {
        linkID, catHouseLivingData, cathouseLivingImg, momentData, 
      } = res?.default || {};
      const newData = {
        linkID,
        catHouseLivingData: shuffleArray((catHouseLivingData as any[]) || []),
        cathouseLivingImg: shuffleImgArray((cathouseLivingImg as any[]) || []),
        momentData: shuffleArray((momentData as any[]) || []),
      };
      curConfigData = newData;
      return Promise.resolve(newData);
    })
    .catch(() => {
      console.log('catch error');
      return Promise.resolve({});
    });

  // eslint-disable-next-line @typescript-eslint/require-await
  // return new Promise(async (resolve) => {
  //   // const data = await new ClientSDK({ project: 'AppPetH5', env: ENV }).getAll();
  //   // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  //   const data = require('./config.mock.json');
  //   resolve({});
  // });
}

// export const setUrlsConfig = () => {
//   if (curConfigData) return Promise.resolve(curConfigData);
//   const clientConfigEvent = sessionStorage.getItem('clientConfigEvent');
//   let data = null;
//   try {
//     data = JSON.parse((clientConfigEvent || null) as string);
//     curConfigData = data;
//   } catch (error) {
//     //
//   }
//   if (data) {
//     return Promise.resolve(data);
//   }
//   return getMockData().then((res: any) => {
//     const { linkID, catHouseLivingData, cathouseLivingImg, momentData } =
//       res || {};
//     const newData = {
//       linkID,
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
//       catHouseLivingData: shuffleArray(catHouseLivingData || []),
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
//       cathouseLivingImg: shuffleArray(cathouseLivingImg || [], 6),
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
//       momentData: shuffleArray(momentData || []),
//     };
//     curConfigData = newData;
//     sessionStorage.setItem('clientConfigEvent', JSON.stringify(newData));
//     return Promise.resolve(newData || {});
//   });
// };

export interface QueryString {
  [key: string]: unknown;
}

/**
 * 获取页面/指定Url中参数
 * @param url
 * @returns
 */
export const getUrlParams = (url?: string) => {
  const queryString: QueryString = {};
  // const url = (window.location.href || "").replace(/#\//g, "");
  if (url) {
    url.replace(/([^?&=]+)=([^&=]*)/gi, (rs, $1, $2) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      queryString[$1] = decodeURIComponent($2);
      return rs;
    });
  }
  return queryString;
};

/**
 * 解析url参数
 * @param query
 * @returns
 */
export const getQueryString = (query: QueryString = {}, encode = true) => {
  const querylist: string[] = [];

  Object.keys(query).forEach((key) => {
    let value = query[key] as string;

    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    } else {
      value = encode ? encodeURIComponent(value) : value;
    }
    querylist.push(`${key}=${value}`);
  });

  return querylist.join('&');
};

/**
 * 图片裁剪压缩(兼容原有的参数)
 * @param url oss原始url
 * @param width 3倍图片的宽度
 * @param height 3倍图片的高度
 * @returns
 */
export function getOssImageUrl(
  url: string,
  width?: number,
  height?: number,
  scale?: number,
  quality?: number,
) {
  if (
    /https?:\/\//.test(url)
    && !url?.includes('easybike-image.oss-cn-hangzhou.aliyuncs.com')
    && !url?.endsWith('.gif')
  ) {
    const params = getUrlParams(url);

    const props: QueryString = {};

    const xoss = params['x-oss-process'] as string;

    if (xoss) {
      // 设置老的属性
      const propList: string[] = xoss.split('/') || [];
      propList.forEach((prop) => {
        const kv: string[] = prop.split(',');
        if (kv.length > 1) {
          props[kv[0]] = prop;
        }
      });
    }
    // 设置新的属性
    props.quality = `quality,q_${quality || 80}`;

    const inWidth = width
      ? `,w_${scale && width ? Math.floor(width / scale) : width}`
      : '';
    const inHeight = height
      ? `,h_${scale && height ? Math.floor(height / scale) : height}`
      : '';

    // 设置新的属性
    if (inWidth || inHeight) {
      props.resize = `resize${inWidth}${inHeight}`;
    }

    // 调整水印到顺序到最后
    const { watermark } = props;
    if (watermark) {
      delete props.watermark;
      if (!width || width > 200) {
        props.watermark = watermark;
      }
    }

    params['x-oss-process'] = `image/${Object.values(props).join('/')}`;

    const positon = url.lastIndexOf('?');

    return `${url.substring(
      0,
      positon < 0 ? undefined : positon,
    )}?${getQueryString(params)}`;
  }
  return url;
}

/**
 * 获取视频封面
 * @param url
 * @returns
 */
export function getVideoCoverUrl(url: string, width = 0, height = 0) {
  if (url) {
    return `${url}?x-oss-process=video/snapshot,t_1000,f_jpg,w_${width},h_${height},ar_auto`;
  }
  return '';
}

export function _proxyOpenDownload(
  defaultAction: defaultActionCallback,
  linkInstance: LinkInstance,
) {
  const { type } = linkInstance.solution;
  const isIOSWeixin = env.isIOS && env.isWeixin;
  const userAgent = navigator.userAgent.toLowerCase();
  const isHarmony = /(Harmony)|(harmony)/i.test(userAgent);
  
  // iOS微信环境：保留默认唤起功能，但显示自定义蒙层
  if (isIOSWeixin) {
    // 让ULink正常处理唤起，不拦截
    defaultAction();
  } else if (env.isIOS) {
    // iOS其他环境：直接跳转
    window.location.href = linkInstance.solution.downloadUrl;
  } else if (isHarmony) {
    // 鸿蒙环境：不执行任何操作
    Toast.text('请先前往应用商店下载街猫App哦～');
    console.log('鸿蒙环境：不执行任何操作');
  } else {
    // 安卓等其他环境：确保跳转功能正常
    console.log('安卓环境：执行ULink跳转', linkInstance.solution.downloadUrl);
    window.location.href = linkInstance.solution.downloadUrl;
  }
}

/**
 * 显示自定义蒙层（用于iOS等不支持useOpenInBrowerTips的环境）
 */
function showCustomOverlay() {
  // 检查是否已经存在蒙层，避免重复创建
  const existingOverlay = document.getElementById('custom-browser-tips');
  if (existingOverlay) {
    existingOverlay.remove(); // 强制移除旧的蒙层
  }

  const overlayHTML = `
    <div id="custom-browser-tips" onclick="document.getElementById('custom-browser-tips').remove()" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.75); z-index: 9999; cursor: pointer;">
      <style>
        @keyframes arrowPulse {
          0% { opacity: 0.6; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.1); }
          100% { opacity: 0.6; transform: scale(1); }
        }
        .arrow-container {
          position: absolute;
          top: 10px;  
          right: 10px;
          animation: arrowPulse 2s ease-in-out infinite;
        }
        .arrow-head {
          transform: rotate(-45deg) scale(1.4) translate(6px, 0px);
          transform-origin: 115px 20px;
        }
        .dashed-arrow {
          stroke-dasharray: 6, 4;
          stroke-dashoffset: 0;
          animation: dashMove 3s linear infinite;
        }
        @keyframes dashMove {
          0% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: -20; }
        }
        .tips-text {
          position: absolute;
          top: 55px;
          right: 100px;
          font-size: 18px;
          font-weight: bold;
          color: white;
          line-height: 1.5;
          white-space: nowrap;
        }
      </style>
      
      <!-- 虚线弧形箭头指向右上角 -->
      <div class="arrow-container">
        <svg width="140" height="100" viewBox="0 0 140 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- 从文案最后位置开始指向右上角的贝塞尔曲线，添加向下弧度 -->
          <path class="dashed-arrow" d="M50 60 C75 70 95 50 115 20" stroke="white" stroke-width="2" fill="none"/>
          <!-- 三角形箭头头部，使用2D旋转 -->
          <path class="arrow-head" d="M110 25 L115 20 L110 15 Z" fill="white"/>
        </svg>
      </div>
      
      <!-- 文字内容，移到箭头左边，一行展示 -->
      <div class="tips-text">
        若未正常唤起，选择「浏览器打开」
      </div>
    </div>
  `;
  9;
  document.body.insertAdjacentHTML('beforeend', overlayHTML);
}

export function stopModal() {
  // 禁用系统弹窗
  if (env.isIOS || !env.isWeixin) {
    // 重写ULink的系统弹窗方法，禁用系统弹窗
    if (window.ULink && window.ULink.prototype) {
      // 重写showTips方法
      window.ULink.prototype.showTips = function () {
        console.log('iOS微信环境：阻止ULink showTips弹窗显示');
      };
      
      // 重写showModal方法（如果存在）
      if (window.ULink.prototype.showModal) {
        window.ULink.prototype.showModal = function () {
          console.log('iOS微信环境：阻止ULink showModal弹窗显示');
        };
      }
      
      // 重写showDialog方法（如果存在）
      if (window.ULink.prototype.showDialog) {
        window.ULink.prototype.showDialog = function () {
          console.log('iOS微信环境：阻止ULink showDialog弹窗显示');
        };
      }
    }
    
    // iOS微信环境：全局拦截可能的弹窗元素
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as Element;
            // 检查是否是ULink相关的弹窗元素
            if (element.innerHTML.includes('如未正常唤起')
                || element.innerHTML.includes('请点击下面的按钮下载App')
                || element.innerHTML.includes('点击下载')
                || element.innerHTML.includes('或在浏览器中打开重试')
                || element.innerHTML.includes('浏览器中打开')
                || element.innerHTML.includes('重试')) {
              console.log('iOS微信环境：检测到ULink弹窗元素，正在移除');
              element.remove();
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

/**
 * 初始化 ULink
 * @param param0 参数对象
 */
export function initULink({
  id = ULinkIdEnum.AppPetWXSS,
  data,
  selector,
  clipboardStr = '',
  onWakeupCallback,
}: {
  id: string,
  data: any,
  selector: string,
  clipboardStr?: string,
  onWakeupCallback?: () => void,
}) {
  // 防御性检查：如果selector为空或无效，直接返回，避免ULink库报错
  if (!selector || typeof selector !== 'string' || selector.trim() === '') {
    console.warn('initULink: selector参数为空或无效，跳过ULink初始化');
    return;
  }
  
  ULINKSDK().then(() => {
    stopModal();
    // 如果已经存在ULink实例，先销毁它
    if (ulinkInstance) {
      try {
        ulinkInstance.destroy && ulinkInstance.destroy();
      } catch (e) {
        console.log('销毁旧ULink实例失败:', e);
      }
    }
    
    ulinkInstance = new window.ULink([
      {
        id, // 后台生成的裂变活动LinkID
        data,
        selector, // 按钮的名称
        // 可选高级功能，具体含义请看下方U-Link API文档
        auto: false,
        timeout: 2000, // 所有环境使用默认超时时间，保留唤起功能
        lazy: false,
        useOpenInBrowerTips: 'default', // 使用默认配置，保留ULink功能
        proxyOpenDownload: _proxyOpenDownload,
        useClipboard(clipboardToken: string) {
          // 如果H5以前用到了剪切板，且剪切板内容是 scheme://xxx/xx?key=value这种类型的,考虑到app升级，可以参考这种拼接方式`scheme://xxx/xx?key=value&um_clp=${clipboardToken}`
          return `${clipboardStr}${clipboardToken}`;
        },
        onready(ctx: any) {
          if (onWakeupCallback) {
            onWakeupCallback();
          }
          
          // iOS微信环境：显示自定义蒙层
          if (env.isIOS && !env.isHelloPetApp && env.isWeixin) {
            console.log('iOS微信环境检测到，显示自定义蒙层');
            // 延迟显示，确保唤起逻辑执行完毕
            setTimeout(() => {
              showCustomOverlay();
            }, 1000);
          }
          
          // 所有环境都执行wakeup，但通过配置禁用系统弹窗
          const option = {
            action: 'click',
            timeout: 2000,
            ...(env.isAndroid && !env.isWeixin ? { proxyOpenDownload: _proxyOpenDownload } : {}),
          };
          ctx.wakeup({ ...option, action: 'load' });
        },
      },
    ]);
  });
}

/**
 * 下载app
 * @param data 自定义参数
 * @param clipboardStr 剪切板内容
 * @returns
 */
export function downLoadApp({
  ulinkId = ULinkIdEnum.AppPetWXSS,
  data = {} as any,
  clipboardStr = '',
  selector = '',
  onWakeupCallback = () => {},
}) {
  const {
    shareId,
    shareUserId,
    blockType,
    shareForm,
    fromPageId,
    applyOrderId,
    orderId,
    businessId,
    shareType,
    skipScene,
    catHouseId,
    bifrostCode,
    webUrl = '',
    router: qRouter,
    mpPage,
    ...others
  } = getUrlParams(
    (window.location.href || '').replace(/#\//g, ''),
  ) as unknown as FromNativeOrWxParam;
  // let config = null;
  // try {
  //   config = await setUrlsConfig();
  // } catch (error) {
  //   //
  // }
  // const { linkID } = config;
  // if (!linkID) {
  //   // Toast.warning('linkID 为空，请重试～');
  //   return;
  // }
  const bCode = bifrostCode || data?.bifrostCode;
  const wxparam = {
    envVersion: 'release',
    shareUserId,
    path: 'pages/index/index',
    fromPageId,
    applyOrderId,
    ...others,
  };
  if (applyOrderId) {
    Object.assign(wxparam, {
      path: '/pages/apply/apply',
    });
  }
  if (+(skipScene || 0)) {
    Object.assign(wxparam, {
      path: '/pages/cathouse/living/living',
    });
  }

  const livingPageId = 'pages-cathouse-living-living';

  if (+(blockType || 0) === 1 && (businessId || catHouseId)) {
    Object.assign(wxparam, {
      catHouseId: businessId || catHouseId,
      fromPageId: livingPageId,
    });
  } else {
    Object.assign(wxparam, {
      blockType,
      businessId,
    });
  }

  // if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  //   location.href = `${baseWxurl}?${getQueryString(wxparam, false)}`;
  //   return;
  // }
  const router = 'bifrost';

  const appparam = {
    // 传递的自定义动态参数
    fromPageId,
    businessId,
    applyOrderId,
    shareForm,
    blockType,
    shareType,
    scene: 2006,
    ...(Object.keys(others || {}).length ? others : {}),
    ...(data || {}),
    // page: 'pages/cathouse/cathouse-apply-process/cathouse-apply-process',
  };

  const bifrostCodeMap: any = {
    apply_detail: `pages/cathouse/cathouse-apply-list/cathouse-apply-list?applyOrderId=${applyOrderId}`,
    apply: 'pages/cathouse/cathouse-apply-list/cathouse-apply-list',
    apply_process:
      'pages/cathouse/cathouse-apply-process/cathouse-apply-process',
    sitter_home: 'pages/index/index',
    sitter_order_detail: `pages/sitter/sitter-order/order-detail/order-detail?orderId=${orderId}`,
    sitter_board_process: 'pages/resistration/board-process/board-process?current=5',
    certificate: 'pages/activity/anti-abuse-certificate/anti-abuse-certificate?source=h5&traceId=e4bcbb18e4c4bf',
  };

  if (bCode && bifrostCodeMap[bCode]) {
    Object.assign(appparam, {
      page: bifrostCodeMap[bCode],
      router,
    });
  }
  
  if (mpPage && mpPage !== 'undefined') {
    Object.assign(appparam, {
      page: decodeURIComponent(mpPage),
      router,
    });
  }

  if (shareUserId && shareUserId !== 'undefined') {
    Object.assign(appparam, {
      shareUserId,
    });
  }

  if (shareId) {
    Object.assign(appparam, {
      router,
    });
  }
  if (qRouter || data?.router) {
    if (qRouter === 'openWeb' || data?.router === 'openWeb') {
      // 定义新域名
      // const newDomain = 'm.hellobike.com';

      // // 创建正则表达式，匹配任意URL中的旧域名
      // const regex = /https?:\/\/([^\/]+)\//g;

      // // 使用正则表达式进行替换
      // const outputString = (window.location.href).replace(regex, (match, oldDomain) =>
      //   // 返回新域名和路径
      //   `https://${newDomain}/`);
      Object.assign(appparam, {
        router: 'openWeb',
        webUrl: webUrl || encodeURIComponent(data?.webUrl as string),
      });
    } else {
      Object.assign(appparam, {
        router: data?.router || router,
      });
    }
  }
  console.log('appparam', appparam);
  initULink({
    id: ulinkId,
    data: appparam,
    selector,
    clipboardStr,
    onWakeupCallback,
  });
}

export const preloadData = () => {
  preloadResultMap.clear();
  const { shareType, businessId } = getUrlParams(
    (window.location.href || '').replace(/#\//g, ''),
  ) as unknown as FromNativeOrWxParam;
  if (userAgent?.indexOf('micromessenger') !== -1) {
    preloadResultMap.set(
      'requestGetSecondShareCardPromise',
      requestGetSecondShareCardApi({
        shareType,
        businessId,
      }),
    );
  }
  if (shareType && +shareType < 3) {
    preloadResultMap.set(
      'getUserFeedDetailPromise',
      getUserFeedDetailApi({ userFeedId: businessId || '' }),
    );
    preloadResultMap.set(
      'getUserFeedDataPromise',
      getUserFeedDataApi({ userFeedId: businessId || '' }),
    );
  } else {
    preloadResultMap.set(
      'getShareDataPromise',
      getShareDataApi({
        type: +shareType || 3,
        shareType: +shareType || 3,
        catHouseId: businessId || '',
      }),
    );
  }
};

// 回调函数的类型
type ReFn = (...args: any) => void;
// 节流函数的类型
type ThFn = (fn: ReFn, timer: number) => ReFn;
const throttle: ThFn = (fn, timer) => {
  let time: any = null;
  const _throttle = (...args: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    if (time) clearTimeout(time);
    time = setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      fn.apply(this, args);
    }, timer);
  };
  return _throttle;
};
export default throttle;

/**
 * 获取通俗化格式的时间
 * @param timestamp
 * @returns
 */
export function getPopularDateText(timestamp: number) {
  const diffValue = new Date().getTime() - timestamp;
  let result = '';
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = month * 12;

  const $year = diffValue / year;
  const $month = diffValue / month;
  const $week = diffValue / (7 * day);
  const $day = diffValue / day;
  const $hour = diffValue / hour;
  const $min = diffValue / minute;

  if ($year >= 1) result = `${Math.trunc($year)}年前`;
  else if ($month >= 1) result = `${Math.trunc($month)}个月前`;
  else if ($week >= 1) result = `${Math.trunc($week)}周前`;
  else if ($day >= 1) result = `${Math.trunc($day)}天前`;
  else if ($hour >= 1) result = `${Math.trunc($hour)}小时前`;
  else if ($min >= 1) result = `${Math.trunc($min)}分钟前`;
  else result = '刚刚';

  return result;
}

/**
 * urlToBase64
 * ```
 * 分享文件类型 图片链接域名 https://m.hellobike.com 上传地址https://123.hellobike.cn/#/oss
 * ```
 * @param imageUrl
 * @returns
 */
export function urlToBase64(
  imageUrl: string,
  useComplete = false,
  isShare = false,
  isIOS = false,
): Promise<string> {
  if (isShare && isIOS) {
    return Promise.resolve(imageUrl);
  }

  return new Promise((resolve, reject) => {
    // 创建一个图片元素
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // 设置跨域属性，允许跨域加载图片

    img.onload = function () {
      // 创建一个canvas元素
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 设置canvas大小与图片相同
      canvas.width = img.width;
      canvas.height = img.height;

      // 在canvas上绘制图片
      ctx?.drawImage(img, 0, 0);

      let base64 = '';

      // 获取Base64编码（不带文件前缀）
      if (useComplete) {
        base64 = canvas.toDataURL('image/jpeg');
      } else {
        base64 = canvas
          .toDataURL('image/jpeg')
          .replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
      }
      // 调用回调函数，传递Base64结果
      resolve(base64);
    };

    img.onerror = function (err) {
      reject(err);
    };

    // 加载图片
    img.src = imageUrl;
  });
}

export function httpGetBase64(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    request
      .post(
        url,
        {},
        {
          // responseType: 'blob',
          responseType: 'arraybuffer',
        },
      )
      .then((response: any) => {
        const base64 = window.URL.createObjectURL(new Blob([response]));
        resolve(base64);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// export function httpGetBase64(url:string):Promise<string> {
//   return new Promise((resolve, reject) => {
//     request.get(url, {
//       // responseType: 'blob',
//       responseType: 'arraybuffer',
//     }).then((buffer: any) => {
//       // const base64 = window.URL.createObjectURL(new Blob([response]));
//       const base64 = window.btoa(String.fromCharCode(...new Uint8Array(buffer)));
//       resolve(base64);
//     }).catch((error) => {
//       reject(error);
//     });
//   });
// }

/**
 * addQueryToUrl
 * @param url
 * @param param
 * @return {string}
 */
export function addQueryToUrl(url: string, queryObj: QueryString): string {
  if (!url) return '';
  if (!queryObj || !Object.keys(queryObj).length) return url;

  const queryParam = {};
  let lastUrl = url;
  // 如果是挑转到 webview 的链接，并且需要添加链路参数的时候，就有它的必要性了。
  if (url.includes('?')) {
    Object.assign(queryParam, getUrlParams(url) || {});
    // eslint-disable-next-line prefer-destructuring
    lastUrl = url.split('?')[0];
  }
  Object.assign(queryParam, queryObj);
  return `${lastUrl}?${getQueryString(queryParam)}`;
}

/**
 * 获取刘海屏高度
 * @returns
 */
export function getStatusBarHeight() {
  let statusBarHeight = 0;

  if (window.visualViewport) {
    statusBarHeight = window.visualViewport.offsetTop;
  } else if (
    window.screen
    && window.matchMedia('(display-cutout: constant)').matches
  ) {
    const { devicePixelRatio } = window;
    const screenHeight = window.screen.height;
    statusBarHeight = Math.round(24 * devicePixelRatio); // 这里的24需要根据设备实际情况进行调整
  }

  return statusBarHeight;
}

/**
 * 版本号对比（适用于semver规范）
 * @param a 左版本号
 * @param b 右版本号
 * @returns 0: 相等，>0: 左大于右，<0: 左小于右
 */
export const compareVersion = (a = '', b = '') => {
  if (a && b) {
    const aList = a.split('.');
    const bList = b.split('.');
    const minLen = Math.min(aList.length, bList.length);

    let pos = 0;
    let diff = 0;

    while (pos < minLen) {
      diff = parseInt(aList[pos], 10) - parseInt(bList[pos], 10);
      if (diff !== 0) {
        break;
      }
      pos++;
    }

    return diff !== 0 ? diff : aList.length - bList.length;
  }
  return 0;
};

/**
 * 唤端包裹函数
 * @param fn 回调
 * @param id 页面id
 */
export function handleCallNative(
  fn: () => void,
  id?: string,
  options?: Record<string, any>,
  toast?: string,
  toastFn?: () => void,
  useToast?: boolean,
) {
  if (id) {
    downLoadApp({
      data: {
        ...options,
      },
      clipboardStr: '',
      selector: `#${id}`,
    });
  } else {
    let canUseApi = false;
    if (env.isHelloPetApp) {
      canUseApi = compareVersion(env.appVersion, '1.19.5') >= 0;
    }
    if ((!canUseApi || useToast) && toast) {
      Toast.text(toast);
      toastFn?.();
      return;
    }
    fn?.();
  }
}

/**
 *
 * @param base64
 * @returns
 */
export function getUint8Arr(base64: string) {
  // 截取base64的数据内容
  const arr = base64.split(',');
  const mime = arr?.[0]?.match(/:(.*?);/)?.[1];
  const bstr = atob(arr[1]);
  // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
  let n = bstr.length;
  // 创建一个Uint8Array类型的数组以存放二进制数据
  const u8arr = new Uint8Array(n);
  // 将二进制数据存入Uint8Array类型的数组中
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return { u8arr, mime };
}

// 将base64转换为blob
export function dataURLtoBlob(base64: string) {
  const { u8arr, mime } = getUint8Arr(base64);
  return new Blob([u8arr], { type: mime });
}
// 将blob转换为file
export function blobToFile(theBlob: any, fileName = '') {
  theBlob.lastModifiedDate = new Date();
  if (fileName) {
    theBlob.name = fileName;
  }
  return theBlob;
}

/**
 *
 * @param base64
 * @param fileName
 * @returns
 */
export function base64ToFile(base64: string, fileName = '') {
  const { u8arr, mime } = getUint8Arr(base64);
  const blob: any = new Blob([u8arr], { type: mime });
  blob.lastModifiedDate = new Date();
  blob.name = fileName || Date.now();
  return blob;
}

export function styleChange(val: boolean) {
  const { body } = document;
  // 获取用户代理字符串
  const { userAgent } = navigator;
  // 使用正则表达式匹配 Android 版本号
  // eslint-disable-next-line no-useless-escape
  const androidVersionMatch = userAgent.match(/Android\s([\d\.]+)/);
  // 检查匹配结果并提取版本号
  const androidVersion = androidVersionMatch ? androidVersionMatch[1] : null;

  // val 为true时 添加overflow为hidden
  if (val) {
    if (parseInt(String(androidVersion || 0), 10) < 11) {
      body.style.position = 'fixed';
    }
    body.style.overflow = 'hidden';
    body.style.maxHeight = '100%';
  } else {
    body.style.overflow = 'scroll';
    body.style.position = 'relative';
    body.style.minHeight = '100%';
  }
}

/**
 *
 * @param fn
 * @param ms
 * @returns
 */
export function debounce<T>(fn: () => void, ms: number) {
  let timer: NodeJS.Timeout | null = null;
  return (...args: T[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn?.(...(args as []));
    }, ms);
  };
}

/**
 * 验证手机号
 * @param phone
 * @returns
 */

export function isValidPhoneNumber(phone: string) {
  const regex = /^1[3-9]\d{9}$/;
  return regex.test(phone);
}

/**
 * 兼容部分浏览器键盘默认弹起
 * @param event
 * @returns
 */

export function scrollBottom(e: any): void {
  e.target.style.opacity = 0;
  window.setTimeout(() => {
    e.target.style.opacity = 1;
    if (!env.isWeixin) return false;
    window.scrollTo(0, document.body.scrollHeight);
  }, 300);
}
/**
 * set document title when router change
 * @param {String} title title name
 */
export function setTitle(title: string): void {
  document.title = title;
  const iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';
  const iframeCallback = () => {
    setTimeout(() => {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };
  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
}

/**
 * 初始化微信分享
 * 此函数用于在微信环境中配置微信分享功能，包括朋友圈和发送给朋友的分享数据
 * @param shareDetail 包含分享具体信息的对象，如标题、子标题和图标
 */
export async function initWxShare(shareDetail: any) {
  // 检查是否在微信环境中
  console.log(env);
  if (env.isWeixin) {
    // 获取微信JS配置签名
    const data: any = (await getWxJsConfigSignatureApi({})) || {};
    const wxJsConfigSignature = data?.data || {};

    // 确保有有效的签名和分享详情
    if (wxJsConfigSignature?.signature && shareDetail) {
      // 解构分享详情和微信配置签名
      const { title = '', subTitle = '', icon = '' } = shareDetail || {};
      const { nonceStr, signature, timestamp } = wxJsConfigSignature || {};

      // 引入微信SDK
      WXSDK().then((value) => {
        // 初始化微信配置
        wx?.config({
          debug: false, // 开启调试模式
          appId: 'wx4e9cc6da9aa26fa9', // 公众号的唯一标识
          timestamp, // 生成签名的时间戳
          nonceStr, // 生成签名的随机串
          signature, // 签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要使用的JS接口列表
        });
        // 微信配置验证成功后初始化分享数据
        wx?.ready(() => {
          // 配置分享给朋友的信息
          wx.updateAppMessageShareData({
            title, // 分享标题
            desc: subTitle, // 分享描述
            link: window?.location?.href || '', // 分享链接
            imgUrl: icon || DOWNLOAD_IMG.INTRO_VIDEO, // 分享图标
            success() {
              console.log('wxJsConfigSignature', wxJsConfigSignature);
            },
            cancel() {
              console.log('分享取消');
            },
          });
          // 配置分享到朋友圈的信息
          wx.updateTimelineShareData({
            title, // 分享标题
            desc: subTitle, // 分享描述
            link: window?.location?.href || '', // 分享链接
            imgUrl: icon || DOWNLOAD_IMG.INTRO_VIDEO, // 分享图标
            success() {},
            cancel() {
              console.log('分享取消');
            },
          });
        });
        // 微信配置验证失败处理
        wx?.error((res: any) => {});
      });
    }
  }
  return [];
}
/**
 * 监听整个文档的所有点击事件，并在特定条件下触发回调
 * 此函数的目的是为了简化对具有特定数据属性的DOM元素的事件监听，
 * 避免了手动遍历和检查每个元素及其事件的需要
 * 节点属性 data-open="1" 可以自定义哪些可以打开
 * @param callback 被监听的事件触发时所调用的回调函数，默认为空函数
 * 回调函数不接受任何参数，也不返回任何值
 */
export function proxyAllEvent(callback = () => {}, isAll = false) {
  if (env.isHelloPetApp === false) {
    try {
      // 添加事件监听器到文档主体，监听点击事件
      document.body.addEventListener(
        'click', // 监听的事件类型为点击
        (e: any) => {
          const clickCallBack = () => {
            // 当条件满足时，调用回调函数
            callback();
            // 阻止事件进一步传播，防止其他事件监听器响应此事件
            e.stopImmediatePropagation();
          };
          // 全部监听的场景
          if (isAll) {
            clickCallBack();
            return;
          }
          // 检查事件目标对象是否存在且具有指定的数据属性值
          if (e?.target?.dataset?.open === '1') {
            clickCallBack();
          }
        },
        true, // 使用捕获阶段添加事件监听器，以便在事件传播的初始阶段捕获事件
      );
    } catch (error) {
      console.log(error);
    }
  }
}

/**
 * 自定义钩子函数usePageOnShowOrHide用于监听页面的显示或隐藏状态
 * 此钩子函数通过监听浏览器的visibilitychange事件来判断页面的可见性
 * 当页面从隐藏变为显示，或者从显示变为隐藏时，更新页面的显示状态
 *
 * @returns 返回一个数组，包含一个元素onShow，用于表示当前页面是否为显示状态
 */
export function usePageOnShowOrHide() {
  // 使用React的useState钩子定义一个状态变量onShow，用于存储页面当前是否为显示状态
  const [onShow, setOnShow] = useState(true);

  useEffect(() => {
    // 尝试添加一个事件监听器来监听浏览器的visibilitychange事件
    // 这是为了在页面的可见性状态改变时更新onShow的状态
    try {
      window.document.addEventListener('visibilitychange', () => {
        // 如果页面变为可见且之前的状态为不可见，则更新onShow为true
        // 这表示页面从隐藏变为显示
        if (document.visibilityState === 'visible') {
          setOnShow(true);
        } else {
          // 如果页面变为不可见或者之前的状态为可见，则更新onShow为false
          // 这表示页面从显示变为隐藏
          setOnShow(false);
        }
      });
    } catch (error) {
      // 如果在添加事件监听器的过程中发生错误，则打印错误信息
      console.log(error);
    }
  }, []);

  // 返回一个包含onShow状态的数组，供外部使用
  // 外部可以基于此状态判断页面当前的显示或隐藏状态
  return [onShow];
}

/**
 * 自定义hook，用于检测页面滚动并返回是否滚动超过一定距离的标志
 *
 * @returns {boolean[]} hasMore - 表示页面是否滚动超过200px的布尔值
 */
export function useHasMore(limitTop = 200) {
  // 初始化状态，用于指示页面是否滚动超过一定距离
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    // 尝试添加滚动事件监听器
    try {
      // 定义滚动事件处理函数
      const handleScroll = (e: any) => {
        // 获取当前滚动距离
        const scrollTop = e?.srcElement?.scrollingElement?.scrollTop || 0;
        // 如果滚动距离超过200px，更新状态为true
        if (scrollTop > limitTop) {
          setHasMore(true);
        }
      };

      // 当窗口发生滚动时，调用handleScroll函数处理滚动事件
      window.addEventListener('scroll', (e) => handleScroll(e));
    } catch (error) {
      // 如果添加事件监听器过程中发生错误，打印错误信息
      console.log(error);
    }
  }, []);

  // 返回hasMore状态，供组件使用
  return [hasMore];
}

export function obsScrollToBottom(callback = () => {}, distance = 200) {
  window.onscroll = debounce(() => {
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    // 获取当前视窗的高度
    const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // 获取当前滚动条的位置
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    // 如果滚动条位置加上视窗高度等于总高度，则表示滚动到了底部
    if (scrollTop + clientHeight + distance >= scrollHeight) {
      console.log('到底部啦~');
      callback();
      // 执行到达底部后的操作
    }
  }, 300);
}

/**
 * 替换文本中的换行符
 * @param text
 * @returns
 */
export function parseHtmlText(text: string) {
  const res = text.replace(/[\r\n]/g, '<br />');
  return res;
}

/**
 * 页面导航
 * @param url 外部地址,会自动携带locale和tenantId信息
 * @param params
 */
export function jumpToUrl(url: string, params = {}) {
  const { tenantId = '', locale = '' } = getUrlParams();

  window.location.href = addQueryToUrl(url, {
    ...params,
    tenantId,
    locale,
  });
}

export interface OpenLinkOptions {
  title?: string;
  newWebView?: boolean;
  timeoutClose?: number;
  from?: string; // 宿主环境
  isClose?: boolean;
  param?: string;
}
/*
 * 跳转链接公用方法（含魔方链接处理）
 * @param jumpLink
 * @param options OpenLinkOptions
 */
export function jumpToAppConfigUrl(
  jumpLink: string,
  options: OpenLinkOptions = {},
) {
  if (jumpLink) {
    const { isClose } = options || {};
    // export const payCardBindUrl = 'hellopet://hellobike.com/pay_method_manage?fromPage=CardMenu';
    const isLinkWebview = /^(f|ht)tps?:\/\//i.test(jumpLink || '');
    const isAppLink = /hellopet:\/\//.test(jumpLink);
    const params = getUrlParams(jumpLink || '') || {};
    if (isLinkWebview && !params.noOpen) {
      Native.openThirdWeb({ url: jumpLink });
    } else if (isAppLink) {
      const nativeAppVersion = env.appVersion;
      const appVersion = compareVersion(nativeAppVersion, '1.32.5') >= 0;
      if (appVersion) {
        Native.callNative({
          classMap: 'business/pet',
          method: 'gotoAppPage',
          params: {
            page: jumpLink || '',
          },
        }).catch((error) => {
          console.log(error);
        });
      } else {
        Toast.text('当前版本app过低，请升级app1.32.5以上版本');
      }
    } else {
      jumpToUrl(jumpLink);
    }
    if (isClose) {
      setTimeout(() => {
        Native.closeWebView();
      }, options?.timeoutClose || 0);
    }
  }
}

/**
 * 复制文本到剪贴板
 * @param text
 */
export function copyToClipboard(text: string) {
  if (env.isAndroid) {
    const nativeAppVersion = env.appVersion;
    const appVersion = compareVersion(nativeAppVersion, '1.32.6') >= 0;
    if (appVersion) {
      Native.callNative({
        classMap: 'business/pet',
        method: 'copyTextToClipboard',
        params: {
          text,
        },
      }).catch((error) => {
        console.log(error);
      });
    } else {
      Toast.text('当前版本app过低，请升级app1.32.6以上版本');
    }
    return;
  }
  if (window.isSecureContext && navigator.clipboard) {
    navigator.clipboard.writeText(text);
    Toast.text('复制成功');
  } else {
    // 创建一个临时的文本框
    const textArea = document.createElement('textarea');
    // 将要复制的文本赋值给临时文本框
    textArea.value = text;
    // 将临时文本框添加到页面中
    document.body.appendChild(textArea);
    // 选中临时文本框中的文本
    textArea.focus();
    // 执行复制操作
    textArea.select();
    Toast.text('复制成功');
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }
}

/**
 * 获取json文件内容 get请求
 * @param url
 */
export async function fetchJsonFile(url: string): Promise<any> {
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return console.error('Error fetching JSON:', error);
  }
}

/**
 * 页面导航
 * @param hashName 不加#/
 * @param params
 * 外部地址,会自动携带locale和tenantId信息
 */
export function navigateTo(hashName: string, params = {}) {
  const { tenantId = '', locale = '' } = getUrlParams();

  window.location.href = addQueryToUrl(`#/${hashName}`, {
    ...params,
    tenantId,
    locale,
  });
}
